<div class="not-found">
  {{ 'global.error.pageNotFound' | translate }}
</div>

<div class="redirect-container" routerLink="{{ userService.loggedConsult ? '/workplace-summary' : '/summary' }}">
  {{ 'global.redirectHome' | translate }}
</div>